/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import Helmet from "react-helmet"

const Layout = ({ children, currentCatag, singleMeta }) => {
  // const data = useStaticQuery(graphql`
  //   query {

  //   }
  // `)

  return (
    <>
      <Header currentCatag={currentCatag} />
      <div>
        <main className="cwp-main-container">{children}</main>
      </div>
      <footer className="cwp-main-footer">
        © 2020 | Developed by
        <a href="http://cakewp.com/" target="__blank">
          {" "}
          CakeWP
        </a>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
